module.exports = __webpack_public_path__ + "img/onlineCarbg3-2.6c2cf422.png";